<template>
  <div class="card-skeleton" :style="{ width: cardWidth }">
    <animated-placeholder
      :height="imageHeight"
      width="100%"
      :borderBottomLeft="borderBottomLeft"
      :borderBottomRight="borderBottomRight"
    />
    <div class="card-skeleton__description">
      <div class="card-skeleton__description--title">
        <animated-placeholder height="12px" width="50%" />
      </div>
      <div class="card-skeleton__description--subtitle">
        <animated-placeholder height="10px" width="100%" />
        <animated-placeholder height="10px" width="70%" />
      </div>
    </div>
  </div>
</template>

<script setup>
  import { computed } from 'vue'
  import AnimatedPlaceholder from '@/libs/AnimatedPlaceholder.vue'

  const props = defineProps({
    width: { type: String, default: '100%' },
    imageHeight: { type: String, default: '100%' },
    borderBottomLeft: { type: String, default: '5px' },
    borderBottomRight: { type: String, default: '5px' }
  })

  const cardWidth = computed(() => props.width)
</script>

<style lang="scss">
  @import '@/scss/mixings';

  .card-skeleton {
    @include d-flex(column, flex-start, flex-start);
    height: auto;
    padding-bottom: 30px;
    border-radius: 20px;
    border: 1px solid var(--neutral-20);
    background: var(--theme-color);
    &__description {
      @include d-flex(column, flex-start, flex-start);
      gap: 18px;
      align-self: stretch;
      padding: 24px 24px 0px 24px;
      &--title {
        width: 100%;
      }
      &--subtitle {
        @include d-flex(column, flex-start, flex-start);
        gap: 10px;
        width: 100%;
      }
    }
  }
</style>
